import angular from 'angular';
import { isGuid } from '@/shared/utils/guid';

angular.module('cloudX').directive('cxRelationSelect', [
  '$http',
  'appUrls',
  '$timeout',
  'relationNameFilter',
  'recentRelationsSvc',
  'flySvc',
  function($http, appUrls, $timeout, relationNameFilter, recentRelationsSvc, flySvc) {
    return {
      restrict: 'E',
      require: '^ngModel',
      replace: true,
      scope: {
        searchOptions: '=?',
        iClass: '@?',
        ngDisabled: '=?',
      },
      template: `<div class="dropdown" uib-dropdown on-toggle="recentRelationsToggle(open)">
        <div class="input-group {{iClass}}">
          <span class="input-group-addon" ng-if="relation && relation.relationHandlingLevel > 1" title="{{relation.relationHandlingLevelClarification}}">
              <span class="fa-fw fa-inline fa fa-exclamation-triangle" ng-class="relation.relationHandlingLevel == 2 ? 'text-warning' : 'text-danger'"></span>
          </span>
          <input type="text"
                 ng-disabled="disabled"
                 ng-model="value"
                 ng-change="onChange()"
                 uib-search-relation
                 typeahead-on-select="setValue($item)"
                 ng-blur="handleBlur()"
                 ng-focus="ddwOpen=false"
                 class="form-control"
                 placeholder="{{('Search relation' | translate)}}"
                 ng-model-options="{updateOn: 'default blur', debounce: { 'default': 400, 'blur': 0 }}"
                 search-options="searchOptions"
                 ng-disabled="ngDisabled"
                 autocomplete="off"/>
          <span class="input-group-btn">
            <button type="button"
                    class="btn btn-default dropdown-toggle"
                    ng-if="!value"
                    ng-disabled="ngDisabled"
                    uib-dropdown-toggle>
              <span class="caret"></span>
            </button>
            <button class="btn btn-default"
                    ng-if="!!value"
                    ng-disabled="ngDisabled"
                    ng-click="clear()">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </div>
        <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>
          <li ng-repeat="rel in recentRelations">
            <a ng-click="selectRecentRelation(rel)" title="{{ rel | relationNameCode }}">
              <cx-relation-icon type="rel.type" crm="rel.crm" active="rel.isActive"></cx-relation-icon>
              <cx-relation-handling-level handling-level="rel.relationHandlingLevel" clarification="rel.relationHandlingLevelClarification"></cx-relation-handling-level>
              &nbsp;<span ng-bind="rel | relationName"></span>
            </a>
          </li>
        </ul>
        </div>`,
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        scope.value = null;
        scope.relation = null;

        scope.selectRecentRelation = function(relation) {
          if (!relation || !relation.id) return scope.setValue(null);
          $http
            .post(`${appUrls.api}/api/relation/names`, [relation.id], {
              params: { forInvoice: scope.searchOptions.forInvoice },
            })
            .then(
              ({ data = null }) => {
                const [relation] = data;
                if (!relation) {
                  flySvc.warning(
                    scope.searchOptions.forInvoice
                      ? 'msgCannotSelectRelationForInvoices'
                      : 'exceptioncode_1002',
                  );
                  return scope.setValue(null);
                }

                scope.relation = relation;
                scope.value = relation;
                ngModel.$setViewValue(relation);
              },
              () => {
                scope.setValue(null);
              },
            );
        };

        scope.setValue = function(relation) {
          if (!relation || !relation.id) {
            scope.relation = null;
            scope.value = null;
            ngModel.$setViewValue(null);
          } else {
            scope.relation = relation;
            scope.value = relation;
            ngModel.$setViewValue(relation);
          }
        };
        scope.clear = function() {
          scope.value = null;
          scope.relation = null;
          ngModel.$setViewValue(null);
        };
        scope.handleBlur = function() {
          $timeout(function() {
            if (scope.value && !scope.value.id) {
              scope.clear(); //Clear value on blur
            }
          }, 500);
        };
        scope.recentRelationsToggle = function(open) {
          if (open && !scope.recentRelations) {
            scope.recentRelations = recentRelationsSvc.getFiltered(scope.searchOptions);
          }
        };
        scope.recentRelations = recentRelationsSvc.getFiltered(scope.searchOptions);
        if (!scope.recentRelations.length) recentRelationsSvc.reloadRecentRelations();

        const initByRelationById = id => {
          return $http
            .post(`${appUrls.api}/api/relation/names`, [id], {
              params: { forInvoice: scope.searchOptions.forInvoice },
            })
            .then(
              ({ data = null }) => {
                if (data) {
                  const [relation] = data;
                  if (relation) {
                    scope.relation = relation;
                    scope.value = relation;
                    ngModel.$setViewValue(relation);
                    return relation;
                  }
                }

                scope.relation = null;
                scope.value = null;
                ngModel.$setViewValue(null);
              },
              () => {
                scope.relation = null;
                scope.value = null;
                ngModel.$setViewValue(null);
              },
            );
        };

        ngModel.$render = function() {
          const value = ngModel.$viewValue;
          if (!value) {
            scope.relation = null;
            scope.value = null;
            return;
          }
          if (typeof value === 'string' && isGuid(value)) {
            initByRelationById(value);
            return;
          }
          if (!value.id) {
            scope.relation = null;
            scope.value = null;
            return;
          }
          if (!value.name) {
            initByRelationById(value.id);
            return;
          }

          scope.relation = value;
          scope.value = value;
        };
      },
    };
  },
]);
